import React from 'react';
import { MOCK_ENTRIES, MOCK_USERS, CLIMBS } from '@/lib/climbData';
import Icon from '@/components/ui/AppIcon';

export default function LeaderboardKPIs() {
  const approvedEntries = MOCK_ENTRIES.filter((e) => e.status === 'approved');
  const activeUsers = MOCK_USERS.filter((u) => u.status === 'active').length;
  const climbsWithEntries = new Set(approvedEntries.map((e) => e.climbId)).size;
  const pendingEntries = MOCK_ENTRIES.filter((e) => e.status === 'pending').length;

  const kpis = [
    {
      id: 'kpi-members',
      label: 'Membri Attivi',
      value: activeUsers.toString(),
      icon: 'UsersIcon',
      color: 'text-green-400',
      bg: 'bg-green-400/10',
      sub: 'nel club IA Climb',
    },
    {
      id: 'kpi-entries',
      label: 'Tempi Registrati',
      value: approvedEntries.length.toString(),
      icon: 'ClockIcon',
      color: 'text-primary',
      bg: 'bg-primary/10',
      sub: 'verificati da Strava',
    },
    {
      id: 'kpi-climbs',
      label: 'Salite Coperte',
      value: `${climbsWithEntries}/${CLIMBS.length}`,
      icon: 'ArrowTrendingUpIcon',
      color: 'text-accent',
      bg: 'bg-accent/10',
      sub: 'salite con tempi',
    },
    {
      id: 'kpi-pending',
      label: 'In Attesa',
      value: pendingEntries.toString(),
      icon: 'ExclamationTriangleIcon',
      color: 'text-yellow-400',
      bg: 'bg-yellow-400/10',
      sub: 'da verificare',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
      {kpis.map((kpi) => (
        <div
          key={kpi.id}
          className="bg-card border border-border rounded-xl p-4 flex items-center gap-3 card-glow"
        >
          <div className={`${kpi.bg} rounded-lg p-2.5 flex-shrink-0`}>
            <Icon name={kpi.icon as 'UsersIcon'} size={20} className={kpi.color} />
          </div>
          <div>
            <p className="text-xs text-muted-foreground font-medium tracking-wide">{kpi.label}</p>
            <p className={`text-2xl font-bold font-mono-nums ${kpi.color}`}>{kpi.value}</p>
            <p className="text-xs text-muted-foreground">{kpi.sub}</p>
          </div>
        </div>
      ))}
    </div>
  );
}